// removed by extract-text-webpack-plugin
module.exports = {"statisticsModalContainer":"_2kAKxrOdQYyxu72NBuGeqY","ant-modal-content":"_14jGQAIjTkeevP8ZOpN-BL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsModal.less
// module id = 1502
// module chunks = 0